import { Button } from '#app/catalyst-ui/button.js'
import { Link } from '#app/catalyst-ui/link.js'
import { Navbar, NavbarItem, NavbarLabel, NavbarSection, NavbarSpacer } from '#app/catalyst-ui/navbar.js'
import { MainStackedLayout } from '#app/catalyst-ui/stacked-layout.js'
import { useOptionalUser } from '#app/utils/user.js'
import { ArrowRightEndOnRectangleIcon } from '@heroicons/react/20/solid'
import { AcademicCapIcon as LargeAcademicCapIcon } from '@heroicons/react/24/solid'
import { Outlet } from '@remix-run/react'

export default function Index() {
	const user = useOptionalUser()

	return (
		<MainStackedLayout
			navbar={
				<Navbar data-nosnippet className="py-5 md:py-9!">
					<NavbarItem href="/" className="-ml-2 *:rounded-full">
						<div className="-m-0.5 flex size-11 rounded-full bg-radial from-blue-600 to-blue-500 text-white">
							<LargeAcademicCapIcon className="m-auto size-9" />
						</div>

						<NavbarLabel className="sr-only ml-1 text-base font-semibold sm:not-sr-only sm:flex sm:pr-2.5">
							GradeGuide
						</NavbarLabel>
					</NavbarItem>

					<NavbarSpacer />

					<NavbarSection>
						{user ? (
							<Button plain href="/app/degree" aria-label="Login">
								Degree
							</Button>
						) : (
							<>
								<Button plain href="/login" aria-label="Login">
									<ArrowRightEndOnRectangleIcon className="md:hidden" />
									<span className="hidden md:block">Log in</span>
								</Button>

								<Button href="/signup" aria-label="Signup" color="blue">
									<span>Sign up</span>
								</Button>
							</>
						)}
					</NavbarSection>
				</Navbar>
			}
			footer={
				<ul
					data-nosnippet
					className="flex flex-col items-center justify-center gap-x-6 gap-y-3 text-base/6 text-zinc-500 sm:flex-row sm:text-sm/6 dark:text-zinc-400"
				>
					<li>
						<Link href="contact">Contact us</Link>
					</li>

					<li>
						<Link href="terms">Terms of service</Link>
					</li>

					<li>
						<Link href="privacy">Privacy policy</Link>
					</li>
				</ul>
			}
		>
			<Outlet />
		</MainStackedLayout>
	)
}
